import api from "@/lib/api";
import { toast } from "sonner";

const MIME_TYPES = {
  csv: "text/csv",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
};

/**
 * Fetch a paginated leads export as a Blob and trigger the browser download.
 *
 * @param {"csv"|"xlsx"} fmt
 * @param {URLSearchParams} query — the current filter query (pagination limit stripped).
 * @param {string[]} selectedIds — optional list of lead ids to restrict the export to.
 */
export async function downloadLeadsExport(fmt, query, selectedIds = null) {
  const p = new URLSearchParams(query);
  p.delete("limit");
  p.set("max_rows", "50000");
  if (selectedIds && selectedIds.length) {
    p.set("ids", selectedIds.join(","));
  } else if (selectedIds !== null) {
    toast.error("Select at least one lead");
    return;
  }
  const defaultFilename = fmt === "xlsx" ? "leadflow-leads.xlsx" : "leadflow-leads.csv";
  try {
    const resp = await api.get(`/leads/export.${fmt}?${p.toString()}`, { responseType: "blob" });
    const rowsHeader = resp.headers?.["x-rows-exported"] || resp.headers?.["X-Rows-Exported"];
    const filename =
      (resp.headers?.["content-disposition"] || "")
        .split("filename=")[1]?.replace(/"/g, "") || defaultFilename;
    const blob = new Blob([resp.data], { type: MIME_TYPES[fmt] });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    URL.revokeObjectURL(link.href);
    toast.success(`Downloaded ${rowsHeader || "your"} leads (${fmt.toUpperCase()})`);
  } catch (e) {
    toast.error(e.response?.data?.detail || "Export failed");
  }
}

/**
 * Compute the from/to date strings for a rolling window ending today.
 * @param {number} days — window size in days (inclusive).
 * @returns {{ from: string, to: string }}
 */
export function rollingDateRange(days) {
  const to = new Date();
  const from = new Date();
  from.setDate(to.getDate() - days + 1);
  const iso = (d) => d.toISOString().slice(0, 10);
  return { from: iso(from), to: iso(to) };
}
